/** @format */

import React, { useState, useEffect } from "react";
import useSettings from "stores/settings";
import { observer } from "mobx-react-lite";
// import { useRouter } from "next/router";
import { Dropdown } from "react-bootstrap";
import { FormatDate } from "components/FormatDate";
// import commentLikeFunction from "firestore/commentLikeFunction";
import { BasicAlert } from "components/Alert";
import ReportOutlinedIcon from "@material-ui/icons/ReportOutlined";

import Modal from "react-awesome-modal";

import IconButton from "@material-ui/core/IconButton";
// import { HistoryStorageUrl } from "components/HistoryStorageUrl";
import UserPhoto from "components/UserPhoto";
import { projectFirestore } from "components/ProjectFirestore";

import ReportModal from "components/modal/ReportModal";
import UserName from "components/UserName";

const AppDetailComments = observer(({ email, appId, appName }) => {
  const settings = useSettings();
  const [reviewDatas, setReviewDatas] = useState([]);
  useEffect(async () => {
    if (settings.email) {
      try {
        const collectionRef = projectFirestore.collection("gcf").doc(email).collection("app").doc(appId).collection("review");

        const collectionValue = await collectionRef.orderBy("createdAt", "desc").get();
        const tempReviewDatas = [];
        collectionValue.forEach((doc) => {
          if (doc.data().visible) {
            tempReviewDatas.push({ ...doc.data(), id: doc.id });
          }
        });
        setReviewDatas(tempReviewDatas);
      } catch (error) {
        console.error(error);
      }
    }
  }, []);
  return (
    <div className="aiso_detail_footer">
      {/* 전체 후기 - 모달 */}
      <OverviewConmmentsInput reviewDatas={reviewDatas} email={email} appName={appName} />
      {/* 후기 */}
      {reviewDatas && reviewDatas.length > 0 ? (
        reviewDatas.slice(0, 2).map((m) => <ReviewRow {...m} key={m.id} appEmail={email} />)
      ) : (
        <div className="text-base flex justify-center py-5">등록된 후기가 없습니다.</div>
      )}
      {/* <ConmmentsInputText /> */}
    </div>
  );
});

const OverviewConmmentsInput = ({ reviewDatas, email, appName }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="w-full border-b-2 border-white py-2">
      {/* 후기 Top */}
      <div className="flex justify-between items-center px-3">
        <div className="flex items-center">
          <p className="mb-0 text-sm pr-3 font-gmarket-medium">
            사용 후기 <span className="ml-1 font-bold">{`${reviewDatas.length}건`}</span>
          </p>
          <button className="btn glass_in_box_btn p-2 text-sm" onClick={() => setModalVisible(true)}>
            전체 보기
          </button>
          <CommentsModal modalVisible={modalVisible} closeModal={closeModal} reviewDatas={reviewDatas} appEmail={email} appName={appName} />
        </div>
        <Dropdown>
          <Dropdown.Toggle variant="" id="dropdownMenuOutlineButton4" className="no-arrow-dropdown btn glass_in_box_btn p-2">
            <i className="mdi mdi-filter-variant mr-1" />
            <span className="text-sm">정렬</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>
              <i className="fa fa-heart-o mr-3" />
              인기순
            </Dropdown.Item>
            <Dropdown.Item>
              <i className="fa fa-sort-amount-asc mr-3"></i>오래된 날짜순
            </Dropdown.Item>
            <Dropdown.Item>
              <i className="fa fa-sort-amount-desc mr-3"></i>최근 날짜순
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
const CommentsModal = ({ modalVisible, closeModal, appEmail, reviewDatas, appName }) => {
  // const styles = useStyles();
  return (
    // <Modal visible={modalVisible} width="520" height="720" effect="fadeInUp" onClickAway={() => closeModal()}>

    <Modal visible={modalVisible} width="520" height="720" effect="fadeInUp" onClickAway={() => closeModal()} className="rounded-0">
      <div className="aiso-modal rounded-0">
        <div className="aiso-modal-header w-full justify-content-between border-b">
          <div className="flex items-center justify-start py-3">
            <div className="ml-2">
              <p className="text-base font-bold text-333 mb-0 mr-3">{appName}</p>
            </div>
          </div>
          <button className="btn btn-text-grayPrimary p-3" onClick={() => closeModal()}>
            <i className="ti-close font-bold"></i>
          </button>
        </div>
        <div className="w-full border-b border-ddd py-1">
          {/* 후기 Top */}
          <div className="flex justify-between items-center px-3">
            <div className="flex items-center">
              <p className="mb-0 text-gray text-xs pr-2">
                전체 후기 <span className="ml-1 font-black text-primary">{`${reviewDatas.length} 건`}</span>
              </p>
            </div>
            <Dropdown>
              <Dropdown.Toggle variant="" id="dropdownMenuOutlineButton4" className="no-arrow-dropdown btn btn-white2 py-2 px-3 text-sm">
                <i className="mdi mdi-filter-variant mr-1" /> 정렬
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>
                  <i className="fa fa-heart-o mr-3" />
                  인기순
                </Dropdown.Item>
                <Dropdown.Item>
                  <i className="fa fa-sort-amount-asc mr-3"></i>오래된 날짜순
                </Dropdown.Item>
                <Dropdown.Item>
                  <i className="fa fa-sort-amount-desc mr-3"></i>최근 날짜순
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* <div className="popup-body flex flex-col justify-center items-center"> */}
        <div className="aiso-modal-body">
          <div className="w-full overflow-y-auto">
            <div style={{ height: "560px" }}>
              {/* 후기 */}
              {reviewDatas && reviewDatas.length > 0 ? (
                reviewDatas.map((m) => <ReviewRow key={m.id} {...m} appEmail={appEmail} />)
              ) : (
                <div className="text-base text-aaa flex justify-center py-5 font-gmarket-medium">등록된 후기가 없습니다.</div>
              )}
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
    </Modal>
  );
};

const ReviewRow = ({ id, appId, appName, appEmail, email, userName, review, comment, commentedAt, createdAt }) => {
  const photoUrl = UserPhoto(email);
  const photoUrl2 = UserPhoto(appEmail);
  const name = UserName(email);
  // const { historyInputFile, historyOutputFile } = HistoryStorageUrl(inputFile, outputFile);

  // const settings = useSettings();
  // const [commentLike, setCommentLike] = useState(0);
  // const [commentLikeCheck, setCommentLikeCheck] = useState();

  /* 신고 Modal  */
  const [reportModalVisible, setReportModalVisible] = useState(false);

  // useEffect(async () => {
  //   if (settings.email) {
  //     try {
  //       const collectionRef = projectFirestore
  //         .collection("gcf")
  //         .doc(email)
  //         .collection("app")
  //         .doc(appId)
  //         .collection("review")
  //         .doc(id)
  //         .collection("like");

  //       const datas = [];

  //       const collectionValue = await collectionRef.get();
  //       collectionValue.forEach((doc) => {
  //         datas.push({ ...doc.data() });
  //         if (doc.id === settings.email) {
  //           setCommentLikeCheck(doc.data().createdAt);
  //         }
  //       });

  //       setCommentLike(datas.length);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }
  // }, []);

  /* 댓글 좋아요 클릭 */
  // const handleCommentLikeClick = async () => {
  //   /**
  //    * 댓글 좋아요 누르면 바로 저장 & 삭제
  //    * id, appId, userEmail, appEmail, settingsEmail,
  //    * commentLike, setCommentLike, commentLikeCheck, setCommentLikeCheck
  //    */
  //   const { tempCommentLike, tempCommentLikeCheck } = await commentLikeFunction(
  //     id,
  //     appId,
  //     email,
  //     appEmail,
  //     settings.email,
  //     commentLike,
  //     commentLikeCheck
  //   );
  //   setCommentLikeCheck(tempCommentLikeCheck);
  //   setCommentLike(tempCommentLike);
  // };

  return (
    <div className="px-3 px-md-3 py-2">
      <div className="border-b border-gray-300">
        <div className="flex justify-between items-center">
          <div className="flex justify-start items-center w-full">
            <div>
              <div className="img-cover-box w-7 h-7 sm:w-10 sm:h-10">
                <img className="rounded-full border" src={photoUrl} />
              </div>
            </div>
            <div className="whitespace-pre-line break-all ml-2">
              <div className="truncate-1-lines font-bold text-base">{name}</div>
            </div>
          </div>
          <IconButton color="black" onClick={() => setReportModalVisible(true)}>
            <ReportOutlinedIcon />
          </IconButton>
        </div>

        <div className="w-full pb-3 px-5">
          <div className="w-full mt-1">
            {/* 후기내용 */}
            <div>
              <div>
                <div className="mb-0 text-base">{review}</div>
                <div className="mb-0 text-555 mt-1 text-sm flex justify-start">{createdAt ? createdAt.substring(0, 10) : ""}</div>
              </div>
              {/* {imageVisible ? (
              <>
                <div className="w-full h-full flex">
                  <div className="w-full md:w-4/6 pr-5">
                    <div className="w-full h-full flex flex-col justify-between items-stretch">
                      <p className="w-full mb-0 text-333 text-base break-words">{review}</p>
                      <p className="mb-0 text-888 mt-3">{createdAt}</p>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="h-full flex flex-col justify-between items-stretch">
                <p className="w-full mb-0 text-333 text-base break-words">{review}</p>
                <p className="mb-0 text-888 mt-3">{createdAt}</p>
              </div>
            )} */}

              {/* <div className="flex justify-end p-2">
              <button className={`btn btn-white3 text-333 p-0 ${commentLikeCheck ? "active" : ""}`} onClick={handleCommentLikeClick}>
                <i className="fa fa-heart-o m-0 text-13" />
              </button>
            </div> */}
            </div>
            {/* 답변 */}
            {commentedAt === "" ? (
              ""
            ) : (
              <div className="w-full mt-4 border-t pt-3">
                <p className="text-xs text-primary font-bold mb-3">답글</p>
                <div className="flex items-center">
                  <div>
                    <div className="img-cover-box w-8 h-8">
                      <img className="rounded-full border" src={photoUrl2} />
                    </div>
                  </div>
                  <div className="ml-3">
                    <a href="#" className="font-bold text-333 text-base">
                      {userName}
                    </a>
                  </div>
                </div>
                <div className="w-full mt-2 pb-3 px-5">
                  <p className="w-full mb-0 text-333 text-base break-words">{comment}</p>
                  <p className="mb-0 text-888 mt-3">{createdAt}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ReportModalContent
        reportModalVisible={reportModalVisible}
        closeModal={() => setReportModalVisible(false)}
        id={id}
        appId={appId}
        appName={appName}
        appEmail={appEmail}
      />
    </div>
  );
};

// 신고 모달
const ReportModalContent = ({ reportModalVisible, closeModal, id, appId, appName, appEmail }) => {
  const settings = useSettings();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const handleModalOkButton = async () => {
    const date = new Date();
    const createdAt = FormatDate(date);

    if (title === "") {
      const text = "신고 제목을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    if (content === "") {
      const text = "신고 내용을 입력해주세요.";
      BasicAlert(text);
      return;
    }

    closeModal();
    /**
     * 받은 신고 저장 위치 : gcf/{email}/reviewReport/{randomId}
     */

    try {
      const collectionRefAppUser = await projectFirestore.collection("gcf").doc(appEmail).collection("reviewReport");
      const values = {
        email: settings.email,
        userName: settings.name,
        reviewId: id,
        appId,
        appName,
        appEmail,
        title,
        content,
        createdAt,
        status: "미확인",
      };
      await collectionRefAppUser.add(values);
      setTitle("");
      setContent("");
      closeModal();
      BasicAlert("신고내용이 등록되었습니다.");
    } catch (error) {
      console.log(error);
      BasicAlert("신고 등록 실패");
    }
  };
  return (
    <ReportModal
      modalVisible={reportModalVisible}
      closeModal={closeModal}
      handleModalOkButton={handleModalOkButton}
      title={title}
      setTitle={setTitle}
      content={content}
      setContent={setContent}
    />
  );
};
export default AppDetailComments;
